import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["option"];
import I18n from 'I18n';
import { MALFORMED_EMAIL, PREVIOUSLY_BOUNCED, MISSING_PERMISSION } from 'composer-data/email/public/constants';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { InfoIcon, WarningIcon } from 'foundations-assets';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getToolTipString = (emailAddress, validationData, isEmailLoggingBlocked) => {
  if (!validationData.isEmailValid) {
    if (validationData.reason === MALFORMED_EMAIL) {
      return I18n.text('composer-ui.metadata-editor.custom-recipient-tag.tooltip.invalid-email', {
        recipientEmail: emailAddress
      });
    } else if (validationData.reason === PREVIOUSLY_BOUNCED) {
      return I18n.text('composer-ui.metadata-editor.custom-recipient-tag.tooltip.bounced-contact', {
        recipientEmail: emailAddress
      });
    } else if (validationData.reason === MISSING_PERMISSION) {
      return I18n.text('composer-ui.metadata-editor.custom-recipient-tag.tooltip.permissions', {
        recipientEmail: emailAddress
      });
    }
  } else if (isEmailLoggingBlocked) {
    return I18n.text('composer-ui.metadata-editor.custom-recipient-tag.tooltip.never-log', {
      recipientEmail: emailAddress
    });
  }
  return emailAddress;
};
const CustomRecipientTag = props => {
  const {
      option: {
        name,
        address,
        validationData = {},
        isEmailLoggingBlocked
      }
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const tagTextContent = name || address;
  return /*#__PURE__*/_jsx(Tooltip, Object.assign({}, rest, {
    display: "inline-block",
    title: getToolTipString(address, validationData, isEmailLoggingBlocked),
    children: /*#__PURE__*/_jsxs("span", {
      children: [tagTextContent, !validationData.isEmailValid || isEmailLoggingBlocked ? /*#__PURE__*/_jsx(IconHolder, {
        icon: isEmailLoggingBlocked ? InfoIcon : WarningIcon,
        marginInlineStart: "100",
        padding: "0",
        size: "100"
      }) : null]
    })
  }));
};
CustomRecipientTag.displayName = 'CustomRecipientTag';
export default CustomRecipientTag;